

<label>{{ 'common.accounts' | translate }}</label>
<div class="dropdown {{showDdl ? 'open' : ''}}">
  <div class="inner-addon left-addon">
    <i class="glyphicon armx-search"></i>
    <input type="text" class="form-control" placeholder="search" (keyup)="search($event)" [(ngModel)]="searchTerm" />
  </div>
  <ul class="dropdown-menu list-scroll">
    <li *ngFor="let item of tempContent; index as i"
        (click)="change(item)" class="{{i==arrowkeyLocation? 'active' :''}}"><a>{{item[searchKey1]}} - {{item[searchKey2]}}</a></li>
  </ul>
</div>


